"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  IrisScanApproved: ['iris-scan-approved', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.092,9.665C20.463,6.77,16.594,4.2,12.584,4.012,12.389,4,12.2,4,12,4,7.747,4.034,3.876,6.47,1.058,9.5c-.05.054-.1.109-.15.164a3.457,3.457,0,0,0,0,4.669C2.113,15.662,6.471,20,11.872,20h.256c5.4,0,9.759-4.338,10.966-5.667A3.456,3.456,0,0,0,23.092,9.665Zm-1.478,3.322c-2.17,2.388-5.32,4.655-8.642,4.968A8.541,8.541,0,0,1,12,18c-3.63-.085-6.84-2.11-9.286-4.658q-.167-.174-.329-.353a1.478,1.478,0,0,1,0-1.979C4.752,8.4,8.332,5.915,12,6a9.407,9.407,0,0,1,3.747.774,15.249,15.249,0,0,1,3.4,1.977,18.084,18.084,0,0,1,2.47,2.256A1.478,1.478,0,0,1,21.614,12.987Z', 'M12,6.5A5.5,5.5,0,1,0,17.5,12,5.506,5.506,0,0,0,12,6.5Zm3.474,4.354-2.9,3.875a1.751,1.751,0,0,1-2.64.185l-1.5-1.5A1,1,0,0,1,9.844,12l1.094,1.094a.249.249,0,0,0,.377-.027l2.559-3.412a1,1,0,0,1,1.6,1.2Z']],
  IrisScan: ['iris-scan', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,12a4,4,0,1,0,4-4A4,4,0,0,0,8,12Zm5,0a1,1,0,1,1-1-1A1,1,0,0,1,13,12Z', 'M20.886,13.357a.253.253,0,0,0-.079.179.25.25,0,0,0,.073.181l1.059,1.059a.251.251,0,0,0,.348.006c.367-.343.713-.689,1.03-1.034a2.591,2.591,0,0,0,0-3.5c-.316-.343-.661-.689-1.027-1.031a.25.25,0,0,0-.347.006l-1.063,1.063a.251.251,0,0,0,.007.361c.347.32.67.642.961.958a.585.585,0,0,1,0,.787C21.551,12.714,21.228,13.037,20.886,13.357Z', 'M5.457,9.793A1,1,0,0,0,6.871,8.379a.307.307,0,0,1,.072-.488,9.871,9.871,0,0,1,10.113,0,.307.307,0,0,1,.072.488,1,1,0,1,0,1.414,1.414l4.75-4.75a1,1,0,0,0-1.414-1.414L19.157,6.35a.5.5,0,0,1-.6.079,12.086,12.086,0,0,0-13.107,0,.5.5,0,0,1-.6-.079L2.121,3.629A1,1,0,0,0,.707,5.043Z', 'M1.712,14.782a.248.248,0,0,0,.347-.006l1.06-1.059a.251.251,0,0,0-.006-.36c-.342-.32-.665-.643-.961-.963a.586.586,0,0,1,0-.789c.291-.316.614-.637.961-.958a.249.249,0,0,0,.08-.179.254.254,0,0,0-.073-.182L2.059,9.224a.249.249,0,0,0-.347-.006C1.345,9.56,1,9.9.684,10.249a2.6,2.6,0,0,0,0,3.5C1,14.092,1.345,14.439,1.712,14.782Z', 'M18.542,14.207a1,1,0,0,0-1.414,1.415.33.33,0,0,1,.094.283.334.334,0,0,1-.172.243,10.059,10.059,0,0,1-10.1,0,.328.328,0,0,1-.078-.522,1,1,0,1,0-1.414-1.415l-4.75,4.75a1,1,0,0,0,1.414,1.415l2.72-2.721a.5.5,0,0,1,.6-.079,12.074,12.074,0,0,0,13.108,0,.5.5,0,0,1,.6.079l2.721,2.723a1,1,0,1,0,1.414-1.415Z']],
  IrisScanSmartphone: ['iris-scan-smartphone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17,0H7A3,3,0,0,0,4,3V21a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V3A3,3,0,0,0,17,0Zm1,19a.5.5,0,0,1-.5.5H6.5A.5.5,0,0,1,6,19V3.5A.5.5,0,0,1,6.5,3h11a.5.5,0,0,1,.5.5Z', 'M11.000 11.000 A1.000 1.000 0 1 0 13.000 11.000 A1.000 1.000 0 1 0 11.000 11.000 Z', 'M12,7.5c-2.682,0-4.916,2.73-5.4,3.368a.218.218,0,0,0,0,.264c.486.639,2.72,3.368,5.4,3.368s4.916-2.729,5.4-3.368a.216.216,0,0,0,0-.264C16.916,10.229,14.682,7.5,12,7.5ZM12,13a2,2,0,1,1,2-2A2,2,0,0,1,12,13Z']],
  IrisScanLock: ['iris-scan-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.499 7.000 A1.500 1.500 0 1 0 13.499 7.000 A1.500 1.500 0 1 0 10.499 7.000 Z', 'M18.5,9.5h1a4.407,4.407,0,0,1,1.989.486.252.252,0,0,0,.272-.031,20.676,20.676,0,0,0,1.662-1.538,2.034,2.034,0,0,0,0-2.837C20.806,2.869,16.486,0,12.146,0h-.293C7.512,0,3.192,2.87.578,5.58a2.035,2.035,0,0,0,0,2.836C3.19,11.129,7.512,14,11.839,14h.307a10.456,10.456,0,0,0,1.673-.142.25.25,0,0,0,.209-.227A4.49,4.49,0,0,1,18.5,9.5ZM12,11a4,4,0,1,1,4-4A4,4,0,0,1,12,11Z', 'M22.713,15.515a.249.249,0,0,1-.214-.247V14.25a3.5,3.5,0,0,0-7,0v1.018a.249.249,0,0,1-.214.247A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17A1.5,1.5,0,0,0,22.713,15.515ZM19,21.25a1,1,0,1,1,1-1A1,1,0,0,1,19,21.25Zm1.5-6a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25v-1a1.5,1.5,0,1,1,3,0Z']],
  IrisScanSearch: ['iris-scan-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.498 7.000 A1.500 1.500 0 1 0 13.498 7.000 A1.500 1.500 0 1 0 10.498 7.000 Z', 'M12.038,11.113a.064.064,0,0,0,.02-.071A.066.066,0,0,0,12,11a4,4,0,1,1,4-4,3.924,3.924,0,0,1-.659,2.177.25.25,0,0,0,.243.386A6.742,6.742,0,0,1,16.5,9.5a6.957,6.957,0,0,1,3.97,1.243.251.251,0,0,0,.291,0,21.034,21.034,0,0,0,2.662-2.322,2.034,2.034,0,0,0,0-2.837C20.8,2.869,16.485,0,12.145,0h-.293C7.511,0,3.191,2.87.576,5.58a2.037,2.037,0,0,0,0,2.836A18.638,18.638,0,0,0,9.828,13.8a.249.249,0,0,0,.275-.143A7.025,7.025,0,0,1,12.038,11.113Z', 'M23.632,21.87l-2.276-2.281a.251.251,0,0,1-.039-.3,5.451,5.451,0,0,0,.741-2.756,5.53,5.53,0,1,0-5.53,5.53,5.447,5.447,0,0,0,2.756-.741.25.25,0,0,1,.3.039l2.287,2.272a1.23,1.23,0,0,0,1.759,0A1.236,1.236,0,0,0,23.632,21.87Zm-7.1-1.81a3.53,3.53,0,1,1,3.53-3.53A3.536,3.536,0,0,1,16.528,20.06Z']],
  IrisScan2: ['iris-scan-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.390 16.825 A1.485 1.485 0 1 0 13.360 16.825 A1.485 1.485 0 1 0 10.390 16.825 Z', 'M21.474,13.849a.25.25,0,0,0-.28-.025,7.836,7.836,0,0,1-5.53.844.25.25,0,0,0-.249.092.246.246,0,0,0-.022.264,3.9,3.9,0,0,1,.441,1.8,3.959,3.959,0,1,1-3.959-3.959.085.085,0,0,0,.078-.053.083.083,0,0,0-.021-.092A7.925,7.925,0,0,1,10.109,10.2a.246.246,0,0,0-.268-.141A18.243,18.243,0,0,0,.571,15.42a2.015,2.015,0,0,0,0,2.807c2.589,2.685,6.866,5.527,11.149,5.527.1,0,.2,0,.3,0,4.3,0,8.573-2.842,11.161-5.526a2.012,2.012,0,0,0,0-2.808A20.51,20.51,0,0,0,21.474,13.849Z', 'M24,6.927a.743.743,0,0,0-.742-.742h-.341a.247.247,0,0,1-.243-.2,5.451,5.451,0,0,0-4.409-4.409.246.246,0,0,1-.2-.243V.989a.742.742,0,1,0-1.484,0v.34a.246.246,0,0,1-.205.243,5.449,5.449,0,0,0-4.408,4.409.247.247,0,0,1-.244.2h-.34a.743.743,0,0,0,0,1.485h.341a.247.247,0,0,1,.243.2,5.449,5.449,0,0,0,4.408,4.408.248.248,0,0,1,.205.244v.34a.742.742,0,0,0,1.484,0v-.34a.248.248,0,0,1,.2-.244,5.449,5.449,0,0,0,4.408-4.408.247.247,0,0,1,.244-.2h.34A.743.743,0,0,0,24,6.927Zm-5.615,3.292a.247.247,0,0,1-.324-.235V9.9a.742.742,0,1,0-1.484,0v.087a.247.247,0,0,1-.324.235,3.475,3.475,0,0,1-2.226-2.225.247.247,0,0,1,.236-.324h.087a.743.743,0,0,0,0-1.485h-.087a.247.247,0,0,1-.236-.324,3.472,3.472,0,0,1,2.226-2.225.247.247,0,0,1,.324.235v.087a.742.742,0,1,0,1.484,0V3.871a.247.247,0,0,1,.324-.235,3.472,3.472,0,0,1,2.226,2.225.248.248,0,0,1-.236.324h-.087a.743.743,0,0,0,0,1.485h.087a.248.248,0,0,1,.236.324A3.475,3.475,0,0,1,18.385,10.219Z', 'M16.329 6.927 A0.990 0.990 0 1 0 18.309 6.927 A0.990 0.990 0 1 0 16.329 6.927 Z']],
  IrisScanDenied: ['iris-scan-denied', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.499 7.000 A1.500 1.500 0 1 0 13.499 7.000 A1.500 1.500 0 1 0 10.499 7.000 Z', 'M12.291,11.437A.25.25,0,0,0,12.118,11c-.039,0-.079,0-.119,0a4,4,0,1,1,4-4,3.928,3.928,0,0,1-.8,2.375.25.25,0,0,0,.264.392,7.926,7.926,0,0,1,5.591.573.25.25,0,0,0,.266-.027,20.949,20.949,0,0,0,2.1-1.9,2.034,2.034,0,0,0,0-2.837C20.806,2.869,16.486,0,12.146,0h-.293C7.512,0,3.192,2.87.578,5.58a2.035,2.035,0,0,0,0,2.836c2.283,2.368,5.865,4.852,9.617,5.446a.248.248,0,0,0,.259-.128A8.06,8.06,0,0,1,12.291,11.437Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm1.591,6.677,1.237,1.237a1,1,0,1,1-1.414,1.414l-1.237-1.237a.25.25,0,0,0-.354,0l-1.237,1.237a1,1,0,1,1-1.414-1.414l1.237-1.237a.25.25,0,0,0,0-.354l-1.237-1.237a1,1,0,0,1,1.414-1.414l1.237,1.237a.25.25,0,0,0,.354,0l1.237-1.237a1,1,0,0,1,1.414,1.414L19.09,17.323A.25.25,0,0,0,19.09,17.677Z']],
  IrisScan1: ['iris-scan-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,22H2.25A.25.25,0,0,1,2,21.75V17.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H6.5a1,1,0,0,0,0-2Z', 'M1,7.5a1,1,0,0,0,1-1V2.25A.25.25,0,0,1,2.25,2H6.5a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V6.5A1,1,0,0,0,1,7.5Z', 'M23,16.5a1,1,0,0,0-1,1v4.25a.25.25,0,0,1-.25.25H17.5a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2V17.5A1,1,0,0,0,23,16.5Z', 'M22,0H17.5a1,1,0,0,0,0,2h4.25a.25.25,0,0,1,.25.25V6.5a1,1,0,0,0,2,0V2A2,2,0,0,0,22,0Z', 'M10.500 12.000 A1.500 1.500 0 1 0 13.500 12.000 A1.500 1.500 0 1 0 10.500 12.000 Z', 'M4.842,11.257a1.113,1.113,0,0,0,0,1.484c1.7,1.882,4.463,3.8,7.189,3.758,2.724.046,5.484-1.876,7.188-3.758a1.112,1.112,0,0,0,0-1.484c-1.74-1.922-4.509-3.8-7.186-3.756C9.352,7.456,6.582,9.335,4.842,11.257ZM14.5,12A2.5,2.5,0,1,1,12,9.5,2.5,2.5,0,0,1,14.5,12Z', 'M12,4.5a1,1,0,0,0,1-1V2a1,1,0,0,0-2,0V3.5A1,1,0,0,0,12,4.5Z', 'M12,19.5a1,1,0,0,0-1,1V22a1,1,0,0,0,2,0V20.5A1,1,0,0,0,12,19.5Z', 'M23,11H21.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M1,13H2.5a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z']],
  IrisScanUser: ['iris-scan-user', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.500 7.000 A1.500 1.500 0 1 0 13.500 7.000 A1.500 1.500 0 1 0 10.500 7.000 Z', 'M12.632,13.8A5.745,5.745,0,0,1,21.29,10.12a.248.248,0,0,0,.29-.018,20.64,20.64,0,0,0,1.844-1.685,2.036,2.036,0,0,0,0-2.837C20.777,2.839,16.359-.08,12,0,7.622-.082,3.222,2.84.579,5.58a2.038,2.038,0,0,0,0,2.837C1.765,9.651,6.191,13.944,12.147,14c.084,0,.169,0,.254-.008A.249.249,0,0,0,12.632,13.8ZM12,11a4,4,0,1,1,4-4A4,4,0,0,1,12,11Z', 'M20.064,19.306a.251.251,0,0,1-.028-.465,4.253,4.253,0,1,0-3.618-.024.25.25,0,0,1-.034.464,6.122,6.122,0,0,0-3.891,3.7.75.75,0,0,0,.7,1.018h10a.751.751,0,0,0,.7-1.018A6.129,6.129,0,0,0,20.064,19.306ZM16,15a2.149,2.149,0,0,1,.126-.72.251.251,0,0,1,.365-.131A5.652,5.652,0,0,0,19.436,15a5.225,5.225,0,0,0,.764-.056.25.25,0,0,1,.286.266A2.248,2.248,0,0,1,16,15Z']],
  IrisScanApproved1: ['iris-scan-approved-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.499 7.000 A1.500 1.500 0 1 0 13.499 7.000 A1.500 1.500 0 1 0 10.499 7.000 Z', 'M12.291,11.437A.25.25,0,0,0,12.118,11c-.039,0-.079,0-.119,0a4,4,0,1,1,4-4,3.928,3.928,0,0,1-.8,2.375.25.25,0,0,0,.264.392,7.926,7.926,0,0,1,5.591.573.25.25,0,0,0,.266-.027,20.949,20.949,0,0,0,2.1-1.9,2.034,2.034,0,0,0,0-2.837C20.806,2.869,16.486,0,12.146,0h-.293C7.512,0,3.192,2.87.578,5.58a2.035,2.035,0,0,0,0,2.836c2.283,2.368,5.865,4.852,9.617,5.446a.248.248,0,0,0,.259-.128A8.06,8.06,0,0,1,12.291,11.437Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm3.474,5.355-2.9,3.874a1.751,1.751,0,0,1-2.64.185l-1.5-1.5A1,1,0,1,1,15.343,17.5l1.094,1.094a.25.25,0,0,0,.377-.026l2.558-3.413a1,1,0,0,1,1.6,1.2Z']]
};
exports["default"] = _default;